import { useEffect } from "react";
import constants from "../../constants";

const GOOGLE_FONTS_MAP = {
  Nunito: "Nunito:wght@400;500;600;700",
  Pacifico: "Pacifico:wght@400",
  Roboto: "Roboto:wght@400;500;700",
  "Roboto Mono": "Roboto+Mono:wght@400;500;700",
  Lobster: "Lobster:wght@400",
  Lora: "Lora:wght@400;500;600;700",
  Merriweather: "Merriweather:wght@400;700",
  Montserrat: "Montserrat:wght@400;500;600;700",
  Caveat: "Caveat:wght@400;500;600;700",
  "EB Garamond": "EB+Garamond:wght@400;500;600;700",
  "Playfair Display": "Playfair+Display:wght@400;500;600;700",
  Oswald: "Oswald:wght@400;500;600;700",
};

export default function ThemeProvider({ children, themeData }) {
  const fontFamily = themeData?.fontFamily || constants.fontFamily.defaultFont;

  useEffect(() => {
    // Handle colors
    if (themeData) {
      themeData?.primaryColor &&
        document.documentElement.style.setProperty("--color-primary", themeData?.primaryColor);
      themeData?.secondaryColor &&
        document.documentElement.style.setProperty("--color-secondary", themeData?.secondaryColor);
      themeData?.textOnPrimaryColor &&
        document.documentElement.style.setProperty(
          "--color-text-on-primary",
          themeData?.textOnPrimaryColor,
        );
    }

    // Handle font loading and application
    if (fontFamily) {
      loadGoogleFont(fontFamily);
      document.documentElement.style.setProperty("--font-family", fontFamily);
    }
  }, [fontFamily, themeData]);

  const loadGoogleFont = (fontName) => {
    const fontQuery = GOOGLE_FONTS_MAP[fontName];

    if (!fontQuery) {
      console.warn(`Font ${fontName} not found in GOOGLE_FONTS_MAP`);
      return;
    }

    // Remove existing font link if any
    const existingLink = document.querySelector("link[data-font-loader]");

    if (existingLink) {
      existingLink.remove();
    }

    // Add new font link
    const link = document.createElement("link");
    link.href = `https://fonts.googleapis.com/css2?family=${fontQuery}&display=swap`;
    link.rel = "stylesheet";
    link.setAttribute("data-font-loader", "true");
    document.head.appendChild(link);
  };

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
